import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { MemoEvent } from './memo_events';

@Injectable({ providedIn: 'root' })
export class MemoEventProvider extends DomainEventProvider<MemoEvent> {}
